import {
  KEY_AMOUNT_APPLICATION,
  KEY_TERM_APPLICATION,
  DEFAULT_EXPIRES_DAYS_COOKIES,
  KEY_LOAN_PROMOCODE,
  KEY_LOAN_PURPOSE,
  KEY_SEON_FINGERPRINT,
  KEY_IS_GO_TO_EXPERIAN,
} from 'const';
import Cookies from 'js-cookie';

export const getStorageAmountApplication = () => Cookies.get(KEY_AMOUNT_APPLICATION) || 500;
export const setStorageAmountApplication = (amount: number) =>
  Cookies.set(KEY_AMOUNT_APPLICATION, amount?.toString(), {
    expires: DEFAULT_EXPIRES_DAYS_COOKIES,
    sameSite: 'Strict',
    secure: true,
  });
export const removeStorageAmountApplication = () => Cookies.remove(KEY_AMOUNT_APPLICATION);

export const getStorageTermApplication = () => Cookies.get(KEY_TERM_APPLICATION) || 10;
export const setStorageTermApplication = (term: number) =>
  Cookies.set(KEY_TERM_APPLICATION, term?.toString(), {
    expires: DEFAULT_EXPIRES_DAYS_COOKIES,
    sameSite: 'Strict',
    secure: true,
  });
export const removeStorageTermApplication = () => Cookies.remove(KEY_TERM_APPLICATION);

export const getStoragePromoCodeApplication = () => Cookies.get(KEY_LOAN_PROMOCODE) || '';
export const setStoragePromoCodeApplication = (promo_code: string) =>
  Cookies.set(KEY_LOAN_PROMOCODE, promo_code.toString(), {
    expires: DEFAULT_EXPIRES_DAYS_COOKIES,
    sameSite: 'Strict',
    secure: true,
  });
export const removeStoragePromoCodeApplication = () => Cookies.remove(KEY_LOAN_PROMOCODE);

export const getStorageLoanPurpose = () => Cookies.get(KEY_LOAN_PURPOSE) || '';
export const setStorageLoanPurpose = (loan_purpose: any) =>
  Cookies.set(KEY_LOAN_PURPOSE, loan_purpose.toString(), {
    expires: DEFAULT_EXPIRES_DAYS_COOKIES,
    sameSite: 'Strict',
    secure: true,
  });
export const removeStorageLoanPurpose = () => Cookies.remove(KEY_LOAN_PURPOSE);

export const removeCalculatorData = () => {
  Cookies.remove(KEY_LOAN_PURPOSE);
  Cookies.remove(KEY_LOAN_PROMOCODE);
  Cookies.remove(KEY_TERM_APPLICATION);
  Cookies.remove(KEY_AMOUNT_APPLICATION);
};

export const setLocalStorageSeonFingerPrint = (session: string) =>
  localStorage.setItem(KEY_SEON_FINGERPRINT, session.toString());

export const getLocalStorageSeonFingerPrint = () =>
  localStorage.getItem(KEY_SEON_FINGERPRINT) || '';

export const setStorageIsNeedToExperianStep = (isGoToExperian: string) =>
  Cookies.set(KEY_IS_GO_TO_EXPERIAN, isGoToExperian, {
    expires: DEFAULT_EXPIRES_DAYS_COOKIES,
    sameSite: 'Strict',
    secure: true,
  });
